
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PersonalSettings } from '@/components/settings/PersonalSettings';
import { BrandSettings } from '@/components/settings/BrandSettings';
import { NotificationSettings } from '@/components/settings/NotificationSettings';
// import { WebPushNotificationSettings } from '@/components/settings/WebPushNotificationSettings';
import { SecuritySettings } from '@/components/settings/SecuritySettings';
import { PreferenceSettings } from '@/components/settings/PreferenceSettings';
import { useTranslation } from 'react-i18next';

const SettingsPage = () => {
  const { t } = useTranslation();

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-3xl font-bold tracking-tight'>
          {t('settingsPage')}
        </h1>
        <p className='text-muted-foreground mt-2'>
          {t('manageAccountSettings')}
        </p>
      </div>

      <Tabs defaultValue='personal' className='w-full'>
        <TabsList className='w-full md:w-auto grid grid-cols-2 md:grid-cols-5 h-auto gap-4 bg-transparent p-0'>
          <TabsTrigger
            value='personal'
            className='data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'>
            {t('personal')}
          </TabsTrigger>

          <TabsTrigger
            value='brand'
            className='data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'>
            {t('brand')}
          </TabsTrigger>
          <TabsTrigger
            value='notifications'
            className='data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'>
            {t('notifications.title')}
          </TabsTrigger>
          <TabsTrigger
            value='security'
            className='data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'>
            {t('security')}
          </TabsTrigger>
          <TabsTrigger
            value='preferences'
            className='data-[state=active]:bg-primary data-[state=active]:text-primary-foreground'>
            {t('preferences')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value='personal' className='mt-6'>
          <PersonalSettings />
        </TabsContent>

        <TabsContent value='brand' className='mt-6'>
          <BrandSettings />
        </TabsContent>

        <TabsContent value='notifications' className='mt-6 space-y-6'>
          <NotificationSettings />
          {/* <WebPushNotificationSettings /> */}
        </TabsContent>

        <TabsContent value='security' className='mt-6'>
          <SecuritySettings />
        </TabsContent>

        <TabsContent value='preferences' className='mt-6'>
          <PreferenceSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
